/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type HeatingFuelTypeCodeUIDTOV0 = '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11' | '12' | '13' | '14' | '15' | '16' | '17' | '18' | '19' | '20' | '21' | '22' | '23' | '24' | '25' | '26' | '27' | '28' | '29' | '30' | '31' | '32' | '33' | '34' | '35' | '36' | '37' | '51' | '56' | '57' | '58' | '99';

export const HeatingFuelTypeCodeUIDTOV0 = {
    _0: '0' as HeatingFuelTypeCodeUIDTOV0,
    _1: '1' as HeatingFuelTypeCodeUIDTOV0,
    _2: '2' as HeatingFuelTypeCodeUIDTOV0,
    _3: '3' as HeatingFuelTypeCodeUIDTOV0,
    _4: '4' as HeatingFuelTypeCodeUIDTOV0,
    _5: '5' as HeatingFuelTypeCodeUIDTOV0,
    _6: '6' as HeatingFuelTypeCodeUIDTOV0,
    _7: '7' as HeatingFuelTypeCodeUIDTOV0,
    _8: '8' as HeatingFuelTypeCodeUIDTOV0,
    _9: '9' as HeatingFuelTypeCodeUIDTOV0,
    _10: '10' as HeatingFuelTypeCodeUIDTOV0,
    _11: '11' as HeatingFuelTypeCodeUIDTOV0,
    _12: '12' as HeatingFuelTypeCodeUIDTOV0,
    _13: '13' as HeatingFuelTypeCodeUIDTOV0,
    _14: '14' as HeatingFuelTypeCodeUIDTOV0,
    _15: '15' as HeatingFuelTypeCodeUIDTOV0,
    _16: '16' as HeatingFuelTypeCodeUIDTOV0,
    _17: '17' as HeatingFuelTypeCodeUIDTOV0,
    _18: '18' as HeatingFuelTypeCodeUIDTOV0,
    _19: '19' as HeatingFuelTypeCodeUIDTOV0,
    _20: '20' as HeatingFuelTypeCodeUIDTOV0,
    _21: '21' as HeatingFuelTypeCodeUIDTOV0,
    _22: '22' as HeatingFuelTypeCodeUIDTOV0,
    _23: '23' as HeatingFuelTypeCodeUIDTOV0,
    _24: '24' as HeatingFuelTypeCodeUIDTOV0,
    _25: '25' as HeatingFuelTypeCodeUIDTOV0,
    _26: '26' as HeatingFuelTypeCodeUIDTOV0,
    _27: '27' as HeatingFuelTypeCodeUIDTOV0,
    _28: '28' as HeatingFuelTypeCodeUIDTOV0,
    _29: '29' as HeatingFuelTypeCodeUIDTOV0,
    _30: '30' as HeatingFuelTypeCodeUIDTOV0,
    _31: '31' as HeatingFuelTypeCodeUIDTOV0,
    _32: '32' as HeatingFuelTypeCodeUIDTOV0,
    _33: '33' as HeatingFuelTypeCodeUIDTOV0,
    _34: '34' as HeatingFuelTypeCodeUIDTOV0,
    _35: '35' as HeatingFuelTypeCodeUIDTOV0,
    _36: '36' as HeatingFuelTypeCodeUIDTOV0,
    _37: '37' as HeatingFuelTypeCodeUIDTOV0,
    _51: '51' as HeatingFuelTypeCodeUIDTOV0,
    _56: '56' as HeatingFuelTypeCodeUIDTOV0,
    _57: '57' as HeatingFuelTypeCodeUIDTOV0,
    _58: '58' as HeatingFuelTypeCodeUIDTOV0,
    _99: '99' as HeatingFuelTypeCodeUIDTOV0
};

